(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/service/teams-service.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/service/teams-service.js');
'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const isServer = typeof exports === 'object';
let jupiterHelper;
let logger;
if (isServer) {
  const path = require('path');
  const trinidad = require('@svenskaspelab/trinidad-core').core;
  jupiterHelper = require(path.join(__dirname, 'jupiter-helper.es6'));
  logger = trinidad.logger('arena: teams-service');
} else {
  jupiterHelper = svs.arena.service.jupiterHelper;
  logger = svs.arena.logger;
}

const getTeamsAsync = async req => {
  const options = {
    method: 'GET',
    path: '/social/2/syndicates',
    req
  };
  const _await$jupiterHelper$ = await jupiterHelper.streamlinedJupiterCall(options),
    data = _await$jupiterHelper$.data,
    error = _await$jupiterHelper$.error;
  return {
    data: data === null || data === void 0 ? void 0 : data.customerSyndicates,
    error
  };
};
const getRequestsAsync = async req => {
  const options = {
    method: 'GET',
    path: '/social/1/requests',
    req
  };
  const _await$jupiterHelper$2 = await jupiterHelper.streamlinedJupiterCall(options),
    data = _await$jupiterHelper$2.data,
    error = _await$jupiterHelper$2.error;
  return {
    data,
    error
  };
};
const deleteRequestAsync = async (issuerId, syndicateId) => {
  const options = {
    method: 'DELETE',
    path: '/social/1/requests',
    data: {
      issuerId,
      syndicateId
    }
  };
  return await jupiterHelper.streamlinedJupiterCall(options);
};

const getTeamAsync = async (teamId, req) => {
  const options = {
    method: 'GET',
    path: "/social/1/syndicates/".concat(teamId),
    req
  };

  const addUserInfoToRoot = syndicate => {
    var _syndicate$members;
    const userObject = syndicate === null || syndicate === void 0 || (_syndicate$members = syndicate.members) === null || _syndicate$members === void 0 ? void 0 : _syndicate$members.find(member => member.isCurrentMember);
    return userObject ? _objectSpread(_objectSpread({}, syndicate), {}, {
      memberBalance: userObject.memberBalance,
      memberRole: userObject.memberRole,
      memberState: userObject.memberState
    }) : syndicate;
  };
  const _await$jupiterHelper$3 = await jupiterHelper.streamlinedJupiterCall(options),
    data = _await$jupiterHelper$3.data,
    error = _await$jupiterHelper$3.error;
  return {
    data: addUserInfoToRoot(data === null || data === void 0 ? void 0 : data.syndicate) || {},
    error
  };
};

const createTeamAsync = async values => {
  const options = {
    method: 'POST',
    path: "/social/6/syndicates",
    data: {
      syndicateName: values.syndicateName
    }
  };
  const _await$jupiterHelper$4 = await jupiterHelper.streamlinedJupiterCall(options),
    data = _await$jupiterHelper$4.data,
    error = _await$jupiterHelper$4.error;
  return {
    data: data !== null && data !== void 0 && data.syndicateId ? {
      syndicateId: data.syndicateId,
      syndicateState: data.syndicateState
    } : null,
    error
  };
};
const postInvitationlinkAsync = async function (teamId) {
  let initialDeposit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  const initialDepositJupiter = svs.utils.format.CurrencyAsJupiterString(initialDeposit);
  const options = {
    method: 'POST',
    path: "/social/2/syndicates/".concat(teamId, "/invitationlinks"),
    data: {
      initialDeposit: initialDepositJupiter
    }
  };
  const _await$jupiterHelper$5 = await jupiterHelper.streamlinedJupiterCall(options),
    data = _await$jupiterHelper$5.data,
    error = _await$jupiterHelper$5.error;
  return {
    data,
    teamId,
    errorCode: error === null || error === void 0 ? void 0 : error.code
  };
};
const getInvitationlinkAsync = async teamId => {
  const options = {
    method: 'GET',
    path: "/social/1/syndicates/".concat(teamId, "/invitationlinks")
  };
  const _await$jupiterHelper$6 = await jupiterHelper.streamlinedJupiterCall(options),
    data = _await$jupiterHelper$6.data,
    error = _await$jupiterHelper$6.error;
  return {
    data,
    errorCode: error === null || error === void 0 ? void 0 : error.code
  };
};


const postWithdrawFromTeamAsync = async (amount, teamId) => {
  const options = {
    method: 'POST',
    path: "/social/2/syndicates/".concat(teamId, "/transferfromsyn"),
    data: {
      transAmount: svs.utils.format.CurrencyAsJupiterString(amount)
    }
  };
  const _await$jupiterHelper$7 = await jupiterHelper.streamlinedJupiterCall(options),
    data = _await$jupiterHelper$7.data,
    error = _await$jupiterHelper$7.error;
  return {
    data: data !== null && data !== void 0 && data.syndicateAmounts ? {
      playerAccountBalance: data.playerAccountBalance,
      memberBalance: data.memberBalance,
      syndicateBalance: data.syndicateAmounts.syndicateBalance,
      playableAmount: data.syndicateAmounts.playableAmount
    } : null,
    error
  };
};
const postRequestActivationAsync = async syndicateId => {
  const options = {
    method: 'POST',
    path: '/social/1/syndicates/reactivaterequest',
    data: {
      syndicateId
    }
  };
  const _await$jupiterHelper$8 = await jupiterHelper.streamlinedJupiterCall(options),
    data = _await$jupiterHelper$8.data,
    error = _await$jupiterHelper$8.error;
  return {
    data,
    error
  };
};
const putActivateMemberAsync = async (customerId, syndicateId) => {
  const jupiterOptions = {
    method: 'PUT',
    path: "/social/6/syndicates/".concat(syndicateId, "/member"),
    data: {
      memberId: customerId,
      reactivateMember: true
    }
  };
  return await jupiterHelper.streamlinedJupiterCall(jupiterOptions);
};
const putAdminMemberAsync = async (customerId, syndicateId, activate) => {
  const jupiterOptions = {
    method: 'PUT',
    path: "/social/6/syndicates/".concat(syndicateId, "/member"),
    data: {
      memberId: customerId,
      newAdminStatus: activate ? 'IS_ADMIN' : 'NOT_ADMIN'
    }
  };
  return await jupiterHelper.streamlinedJupiterCall(jupiterOptions);
};
const postDeactivateMemberAsync = async (customerId, syndicateId) => {
  const jupiterOptions = {
    method: 'POST',
    path: "/social/2/syndicates/".concat(syndicateId, "/setshare"),
    data: {
      members: [customerId],
      amount: '0,00',
      setShareType: 'TRANSFER_MONEY',
      comment: 'passive'
    }
  };
  return await jupiterHelper.streamlinedJupiterCall(jupiterOptions);
};
const postMemberNotificationAsync = async (syndicateId, customerIds, message) => {
  const jupiterOptions = {
    method: 'POST',
    path: '/social/1/syndicates/membernotification',
    data: {
      syndicateId,
      message,
      customerIds
    }
  };
  return await jupiterHelper.streamlinedJupiterCall(jupiterOptions);
};

const deleteInviteeAsync = async (teamId, invitationId) => {
  const jupiterOptions = {
    method: 'DELETE',
    path: "/social/4/syndicates/".concat(teamId, "/member?invitationId=").concat(invitationId)
  };
  return await jupiterHelper.streamlinedJupiterCall(jupiterOptions);
};

const postRemindInviteeAsync = async invitationId => {
  const jupiterOptions = {
    method: 'POST',
    path: '/social/1/syndicates/invitationreminders',
    data: {
      invitationId
    }
  };
  return await jupiterHelper.streamlinedJupiterCall(jupiterOptions);
};
const deleteMemberAsync = async (teamId, memberId) => {
  const jupiterOptions = {
    method: 'DELETE',
    path: "/social/4/syndicates/".concat(teamId, "/member?memberId=").concat(memberId)
  };
  return await jupiterHelper.streamlinedJupiterCall(jupiterOptions);
};
const putTerminateSyndicateAsync = async teamId => {
  const jupiterOptions = {
    method: 'PUT',
    path: "/social/4/syndicates/".concat(teamId),
    data: {
      terminate: true
    }
  };
  return await jupiterHelper.streamlinedJupiterCall(jupiterOptions);
};
const putAdminWagerSyndicateAsync = async (teamId, activation) => {
  const jupiterOptions = {
    method: 'PUT',
    path: "/social/4/syndicates/".concat(teamId),
    data: {
      newAdminManagedWagers: activation ? 'TRUE' : 'FALSE'
    }
  };
  return await jupiterHelper.streamlinedJupiterCall(jupiterOptions);
};
const getPlayerEmailAsync = async () => {
  const useOldJupiterApi = !svs.core.detect.feature('ft-elza-email-for-team');
  if (useOldJupiterApi) {
    const jupiterOptions = {
      method: 'GET',
      path: '/player/1/email'
    };
    return await jupiterHelper.streamlinedJupiterCall(jupiterOptions);
  }

  try {
    var _contacts$email, _contacts$email2;
    const svsFetch = svs.core.svsFetch.create();
    const response = await svsFetch('/contacts/v1/customers/me?select=email', {
      method: 'GET'
    });
    if (!response.ok) {
      if ([401, 403].includes(response.status)) {
        window.location.href = '/logga-ut';
        return {
          data: null,
          error: {
            code: response.status,
            message: response.status === 403 ? 'forbidden' : 'unauthorized'
          }
        };
      }
      const body = await response.json().catch(() => null);
      const errorDetail = (body === null || body === void 0 ? void 0 : body.title) || (body === null || body === void 0 ? void 0 : body.detail) || 'Error fetching player email';
      return {
        data: null,
        error: {
          code: Number(body === null || body === void 0 ? void 0 : body.errorCode) || response.status,
          message: errorDetail
        }
      };
    }
    const body = await response.json();
    const contacts = (body === null || body === void 0 ? void 0 : body.data) || {};
    return {
      data: {
        email: ((_contacts$email = contacts.email) === null || _contacts$email === void 0 || (_contacts$email = _contacts$email.address) === null || _contacts$email === void 0 ? void 0 : _contacts$email.toLowerCase()) || '',
        emailStatus: ((_contacts$email2 = contacts.email) === null || _contacts$email2 === void 0 ? void 0 : _contacts$email2.status.code) || ''
      },
      error: null
    };
  } catch (err) {
    logger.error('Error fetching player email (Elza):', err);
    return {
      data: null,
      error: {
        code: err.code || 'network-error',
        message: (err === null || err === void 0 ? void 0 : err.message) || 'Error fetching player email'
      }
    };
  }
};
const getPlayerId = async () => {
  const useOldJupiterApi = !svs.core.detect.feature('ft-elza-properties');
  if (useOldJupiterApi) {
    var _data$playerPropertie;
    const jupiterOptions = {
      method: 'GET',
      path: '/player/1/properties'
    };
    const _await$jupiterHelper$9 = await jupiterHelper.streamlinedJupiterCall(jupiterOptions),
      data = _await$jupiterHelper$9.data,
      error = _await$jupiterHelper$9.error;
    return {
      data: data === null || data === void 0 || (_data$playerPropertie = data.playerProperties) === null || _data$playerPropertie === void 0 ? void 0 : _data$playerPropertie.customerId,
      error
    };
  }
  try {
    var _body$data;
    const svsFetch = svs.core.svsFetch.create();
    const response = await svsFetch('/player-accounts/v1/customers/me', {
      method: 'GET'
    });
    if (!response.ok) {
      if ([401, 403].includes(response.status)) {
        window.location.href = '/logga-ut';
        return {
          data: null,
          error: {
            code: response.status,
            message: response.status === 403 ? 'forbidden' : 'unauthorized'
          }
        };
      }
      const body = await response.json().catch(() => null);
      const errorDetail = (body === null || body === void 0 ? void 0 : body.title) || (body === null || body === void 0 ? void 0 : body.detail) || 'Error fetching customer id';
      return {
        data: null,
        error: {
          code: Number(body === null || body === void 0 ? void 0 : body.errorCode) || response.status,
          message: errorDetail
        }
      };
    }
    const body = await response.json();
    return {
      data: body === null || body === void 0 || (_body$data = body.data) === null || _body$data === void 0 ? void 0 : _body$data.customerId,
      error: null
    };
  } catch (err) {
    logger.error('Error fetching customer id (Elza):', err);
    return {
      data: null,
      error: {
        code: err.code || 'network-error',
        message: (err === null || err === void 0 ? void 0 : err.message) || 'Error fetching customer id'
      }
    };
  }
};
const exportedFunctions = {
  getTeamAsync,
  getTeamsAsync,
  getRequestsAsync,
  deleteRequestAsync,
  createTeamAsync,
  postInvitationlinkAsync,
  getInvitationlinkAsync,
  postWithdrawFromTeamAsync,
  postRequestActivationAsync,
  putActivateMemberAsync,
  postDeactivateMemberAsync,
  putAdminMemberAsync,
  postMemberNotificationAsync,
  deleteInviteeAsync,
  postRemindInviteeAsync,
  deleteMemberAsync,
  putTerminateSyndicateAsync,
  putAdminWagerSyndicateAsync,
  getPlayerEmailAsync,
  getPlayerId
};

if (isServer) {
  module.exports = exportedFunctions;
} else {
  svs.arena.service.teamsService = exportedFunctions;
}

 })(window);